import { gql } from '@apollo/client';

export const SEARCH_TOOL_INVENTORIES = gql`
  query SearchToolInventories($searchInput: SearchInput) {
    searchToolInventories(searchInput: $searchInput) {
      items {
        id
        barCode
        toolCatalogId
        onHandCount
        onOrderCount
        description
        isSerialized
        createdBy
        createdByUser {
          firstName
          lastName
        }
        createdDate
        toolCatalog {
          id
          bscnPartNumber
          name
          inventoryType
          toolCategoryId
          toolCatalogImageUrl
          uomId
          uom {
            abbreviation
            id
          }
          toolCategory {
            id
            name
            toolType {
              name
              id
            }
          }
        }
      }
    }
  }
`;
